import React from 'react'
import { ColorBox, LegendContainer, LegendItem } from './style';
import { formatNumber } from '~/utils/helpers';

interface Props {
  items: {
    color: string,
    label: string,
    value: string | number
  }[]
}

const Legend: React.FC<Props> = ({ items }) => {
  return (
    <LegendContainer>
      {items.map((item, index) => (
        <LegendItem key={index}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ColorBox color={item.color} />
            <div
              style={{ marginLeft: 8, color: item.color, fontStyle: 'italic' }}
              dangerouslySetInnerHTML={{ __html: `${item.label} (${formatNumber(item.value, 2)} kg CO<sub>2</sub>-Äq./kg Milch)` }} />
          </div>
        </LegendItem>
      ))}
    </LegendContainer>
  );
};
export default Legend